export const toggleResetFilter = (resetButtonTarget, searchParams = null, hasResetButtonTarget = false) => {
  const filtersApplied = $.deparam(searchParams)
  if (hasResetButtonTarget && (filtersApplied.search_attributes.search_text || Object.keys(filtersApplied.search_attributes).length > 2)) {
    resetButtonTarget.removeAttribute('disabled')
  } else {
    resetButtonTarget.setAttribute('disabled', 'true')
  }
}
